import { List } from 'immutable';

const prefix = ['app', 'maintenance'];

export const AppraisalNoticeFormsSelector = (state) =>
  state
    .getIn(
      [...prefix, 'websiteAdmin', 'appraisalNoticeForms', 'data'],
      List([]),
    )
    .toJS();

export const AppraisalNoticeFormOptionsSelector = (state) =>
  state
    .getIn(
      [...prefix, 'websiteAdmin', 'appraisalNoticeFormOptions', 'data'],
      List([]),
    )
    .toJS();

export const ReportsSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'reports', 'data'], List([])).toJS();

export const ReportCategoriesSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'reportCategories'], List([])).toJS();

export const ReportTypesSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'reportTypes'], List([])).toJS();

export const TaxingUnitsSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'taxingUnits'], List([])).toJS();

export const FormsSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'forms', 'data'], List([])).toJS();

export const FormTypesSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'formTypes'], List([])).toJS();

export const NewsSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'news', 'data'], List([])).toJS();

export const AnnouncementsSelector = (state) =>
  state
    .getIn([...prefix, 'websiteAdmin', 'announcements', 'data'], List([]))
    .toJS();

export const MembersSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'members', 'data'], List([])).toJS();

export const MeetingsSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'meetings', 'data'], List([])).toJS();

export const LinksSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'links', 'data'], List([])).toJS();

export const LanguagesSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'languages'], List([])).toJS();

export const SettingsSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'settings']).toJS();

export const OnlineFormTypesSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'onlineFormTypes', 'data']).toJS();

export const QuickLinksSelector = (state) =>
  state
    .getIn([...prefix, 'websiteAdmin', 'quickLinks', 'data'], List([]))
    .toJS();

export const TilesSelector = (state) =>
  state.getIn([...prefix, 'websiteAdmin', 'tiles', 'data'], List([])).toJS();
